export default __webpack_public_path__ + "static/media/E-Bikebörse Logo 2.56c081ee.png";